import React, { useContext, useEffect, useState } from "react";
import $ from 'jquery';
// reactstrap components
import {
  Button,
  Modal,
} from "reactstrap";
import { LanguageContext } from "../App";

const InfoFillTable = ({ fillFunction, data }) => {
    const language = useContext(LanguageContext);
    const [showModal, setShowModal] = useState(false);
    const [tableList, setTableList] = useState([]);
    const [itemToDelete, setItemToDelete] = useState(0);

    const toggleModal = () => {
        setShowModal((oldState) => !oldState);
    };

    const TableRow = ({ id, prop_name, prop_info }) => {
        return (
            <tr>
                <td>{id}</td>
                <td className="prop" contentEditable={true}>{prop_name}</td>
                <td className="info" contentEditable={true}>{prop_info}</td>
                <td><button onClick={() => setItemToDelete(id)} className="btn btn-danger btn-sm">remove</button></td>
            </tr>
        );
    };

    const addLine = () => {
        try {
            let prop_name = $('#prop_name').val();
            let prop_info = $('#prop_info').val();
            let new_id = tableList.length + 1;
            let element = <TableRow key={new_id} id={new_id} prop_name={prop_name} prop_info={prop_info} />;
            setTableList(tableList.concat([element]));
        } catch (e) {
            console.log(e.message);
        }
    };

    const addLines = (lines) => {
        setTableList(lines);
    };

    const removeItemById = (id) => {
        setTableList(old => old.filter(element => element.props.id !== id));
    };

    useEffect(() => {
        let lines = [];
        let video_name = (data?.video_name) ? data?.video_name : 'video.mp4';
        lines.push(<TableRow key={1} id={1} prop_name={"original video name"} prop_info={video_name} />);
        lines.push(<TableRow key={2} id={2} prop_name={"sex"} prop_info={"male"} />);
        lines.push(<TableRow key={3} id={3} prop_name={"Action"} prop_info={"Run"} />);
        addLines(lines);
    }, []);

    useEffect(() => {
        if (itemToDelete) {
            removeItemById(itemToDelete);
            setItemToDelete(0);
        }
    }, [itemToDelete]);

    useEffect(() => {
        // Pass actual data to fillFunction instead of just a URL
        const tableData = tableList.map((line) => ({
            name: line.props.prop_name,
            value: line.props.prop_info
        }));
        fillFunction(tableData);
    }, [tableList]);

    const saveInfos = () => {
        const getProps = () => {
            let props = [];
            $('.prop').each((_, el) => {
                props.push(el.innerText);
            });
            return props;
        };

        const getInfos = () => {
            let infos = [];
            $('.info').each((_, el) => {
                infos.push(el.innerText);
            });
            return infos;
        };

        const constructTableList = () => {
            let props = getProps();
            let infos = getInfos();
            let lines = [];
            for (let i = 0; i < props.length; i++) {
                lines.push(<TableRow key={i + 1} id={i + 1} prop_name={props[i]} prop_info={infos[i]} />);
            }
            return lines;
        };

        const lines = constructTableList();
        setTableList(lines);
        toggleModal();
    };

    const keyUpHandler = (event) => {
        if (event.key === 'Enter') addLine();
    };

    return (
        <>
            <br />
            <Button
                className="ml-2"
                color="dark"
                type="button"
                onClick={toggleModal}
            >
                {language.video.acquisition_info.btn}
            </Button>
            <Modal
                className="modal-dialog-centered"
                isOpen={showModal}
                toggle={toggleModal}
            >
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                        {language.video.acquisition_info.h}
                    </h5>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={toggleModal}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <p>{language.video.acquisition_info.p}</p>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{language.video.acquisition_info.property}</th>
                                <th>{language.video.acquisition_info.info}</th>
                                <th>{language.video.acquisition_info.remove}</th>
                            </tr>
                        </thead>
                        <tbody id="fillable_table_body">
                            {tableList}
                        </tbody>
                    </table>
                    <center>
                        <div className="row">
                            <div className="col">
                                <input type="text" className="form-control form-control-alternative" id="prop_name" placeholder="Property name" onKeyUp={keyUpHandler} />
                            </div>
                            <div className="col">
                                <input type="text" className="form-control form-control-alternative" id="prop_info" placeholder="Information" onKeyUp={keyUpHandler} />
                            </div>
                            <div className="col">
                                <Button
                                    color="secondary"
                                    data-dismiss="modal"
                                    type="button"
                                    onClick={addLine}
                                >{language.video.acquisition_info.add}</Button>
                            </div>
                        </div>
                    </center>
                </div>
                <div className="modal-footer">
                    <Button
                        color="secondary"
                        data-dismiss="modal"
                        type="button"
                        onClick={toggleModal}
                    >
                        {language.video.acquisition_info.close}
                    </Button>
                    <Button color="primary" type="button" onClick={saveInfos}>
                        {language.video.acquisition_info.save}
                    </Button>
                </div>
            </Modal>
            <br />
            <br />
        </>
    );
};

export default InfoFillTable;
